import * as z from 'zod';

/**
 * Adds password requirements as refinements to a zod string schema.
 * @param schema The zod string schema to add requirements to.
 */
export function withPasswordRequirements(schema: z.ZodString) {
  const errorNs = 'unauthenticated.common';
  return schema
    .min(8)
    .refine(val => /[A-Z]/.test(val), {
      message: `${errorNs}:error.passwordRequirementUppercase`,
    })
    .refine(val => /[a-z]/.test(val), {
      message: `${errorNs}:error.passwordRequirementLowercase`,
    })
    .refine(val => /\d/.test(val), {
      message: `${errorNs}:error.passwordRequirementNumber`,
    });
}
